import { render, staticRenderFns } from "./RoundDownloadTemp.vue?vue&type=template&id=06939353&scoped=true&"
import script from "./RoundDownloadTemp.vue?vue&type=script&lang=js&"
export * from "./RoundDownloadTemp.vue?vue&type=script&lang=js&"
import style0 from "./RoundDownloadTemp.vue?vue&type=style&index=0&id=06939353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06939353",
  null
  
)

export default component.exports